module.exports = __webpack_public_path__ + "static/media/alert_partner_white_x1_new.77e8e283.png";